// ./modules/components/g6_tooltip.mjs
// ==================================================
// dependencies
import G6 from '@antv/g6';
// --------------------------------------------------

// => tooltips
// --------------------------------------------------
var tooltip = new G6.Tooltip({
  // > offset
  offsetX: 20,
  offsetY: 30,
  trigger: 'hover',
  itemTypes: ['node'],
  // > tooltip's content
  getContent: function getContent(e) {
    // remoteCall(e);
    var model = e.item.getModel();
    var outDiv = document.createElement('div');
    var showJobAndSource = !model.is_node;
    var nodeHtml = "\n    \n    <h4>Detalles:</h4>\n    <ul>\n      <li>Tipo de objeto: ".concat(e.item.getModel().table_type, "</li>\n      <li>Proyecto: ").concat(e.item.getModel().project, "</li>\n      <li>Dataset: ").concat(e.item.getModel().dataset, "</li>\n      <li>Tabla: ").concat(e.item.getModel().name, "</li>\n      ").concat(showJobAndSource ? "<li>Job: ".concat(model.process_name, "</li>") : '', "\n      ").concat(showJobAndSource ? "<li>Fuente: ".concat(model.source, "</li>") : '', "\n    </ul>\n    ");
    outDiv.innerHTML = "".concat(nodeHtml);
    return outDiv;
  },
  shouldBegin: function shouldBegin(e) {
    if (e.target.get('name') === 'info-icon') return true;
    return false;
  }
});

// => exports
export { tooltip };